/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useState, useEffect } from "react";
import { Box, Grid, Button, Typography, TextField } from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { useFormik } from "formik";
import EditIcon from "@mui/icons-material/Edit";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { toast } from "react-toastify";
import {
  BaseUrl,
  User_Detail,
  ImageBase,
  User_Update,
} from "../../services/Url";
import { Loader } from "../../Components/Loader";
import axios from "axios";
import ProfilePic from '../../Components/assets/images/profilePicture.png'

const UserEdit = () => {
  const [singleData, setSingleData] = useState("");
  const [profileImg, setProfileImg] = useState(singleData?.user?.profile_picture ? ImageBase + singleData?.user?.profile_picture : '');
  const [userRole, setUserRole] = useState('');
  const [isloading, setIsloading] = useState(true);
  const [newImage, setNewImage] = useState("");
  const [error, setError] = useState(false);
  const params = useParams();
  const navigate = useNavigate();

  let token = localStorage.getItem("token");
  // token = JSON.parse(token);

  useEffect(() => {
    if(singleData && singleData?.user?.role) {
    setUserRole(singleData?.user?.role)
    }
  },[singleData])

  const imageHandler = (val) => {
    const getImage = val.target.files[0];
    const imgUrl = URL.createObjectURL(getImage);
    setNewImage(getImage);
    setProfileImg(imgUrl);
  };

  /* Single fetch api APi */
  const singleDetail = async () => {
    let CompleteUrl = BaseUrl + User_Detail + `/${params.id}`;
    await fetch(CompleteUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
    })
      .then(async (res) => {
        setIsloading(false);
        const responseData = await res.json();
        if (responseData.response !== 200) {
          setSingleData(responseData.data);
          // console.log(responseData.data);
          // setProfileImg(ImageBase+"/"+singleData?.user?.profile_picture)
          toast.success(responseData.success);
         
        } else return;
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    setTimeout(() => {
      singleDetail();
    }, 1500);
  }, []);

  /* end fetch api */
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      fname: singleData?.user?.first_name || "",
      lname: singleData?.user?.last_name || "",
      userName: singleData?.user?.username || "",
      email: singleData?.user?.email || "",
      phone: singleData?.user?.phone_number || "",
      address: singleData?.user?.address || "",
      country: singleData?.user?.country || "",
      postcode: singleData?.user?.postcode || "",
      city: singleData?.user?.city || "",
      dob: singleData?.user?.dob || "",
      totalGroup: singleData?.total_group_created || "",
      totalParticipant: singleData?.total_group_participated || "",
      memberType: singleData?.user?.member_type || "",
      membership: singleData?.user?.membership_purchased_date || "",
    },
    validationSchema: Yup.object({
      fname: Yup.string().required("First Name must be required"),
      lname: Yup.string().required("Last Name must be required"),
      userName: Yup.string().required("User Name must be required"),
      email: Yup.string().required("email must be required"),
      phone: Yup.string().max(11).min(11).required("Phone Number must be required"),
      address: Yup.string().required("Address must be required"),
      country: Yup.string().required("Country must be required"),
      postcode: Yup.string().required("Post code must be required"),
      city: Yup.string().required("City must be required"),
      dob: Yup.string().required("Date of Birth must be required"),
    }),
    onSubmit: async () => {
      formik.setSubmitting(true);
      setError(true);

      // let body = {
      //     first_name: formik.values.fname,
      //     last_name: formik.values.lname,
      //     phone_number: formik.values.phone,
      //     address: formik.values.address,
      //     profile_picture: newImage,
      //     country: formik.values.country,
      // }
      let CompleteUrl = BaseUrl + User_Update + `/${params?.id}`;

      let formdata = new FormData();
      formdata.append("first_name", formik.values.fname);
      formdata.append("last_name", formik.values.lname);
      formdata.append("profile_picture", newImage);
      formdata.append("phone_number", formik.values.phone);
      formdata.append("address", formik.values.address);
      formdata.append("country", formik.values.country);
      formdata.append("postcode", formik.values.postcode);
      formdata.append("dob", formik.values.dob);
      formdata.append("city", formik.values.city);
      formdata.append("role", userRole);

      axios({
        method: "post",
        url: CompleteUrl,
        data: formdata,
        headers: {
          "Content-Type": "multipart/form-data",
          "x-access-token": token,
        },
      })
        .then(function (response) {
          if (response.response !== 200) {
            navigate(`/users`);
          } else {
            return;
          }
        })
        .catch(function (response) {
          //handle error
          console.log(response);
        });

      // editHandler(params.id,formdata);
      formik.setSubmitting(false);
      setError(false);
    },
  });

  const USER_ROLES = {
    ADMIN: "admin",
    USER: "user",
    TEST: "test",
  }

  return (
    <Box
      display="flex"
      className="box-wrapper br-24 table_bx"
      flexDirection="column"
      justifyContent="flex-start"
    >
      {isloading ? <Loader /> : ""}
      <div className="heading-btn_wrapper">
        <h5
          style={{ display: "inline-flex", cursor: "pointer" }}
          className="fz-20 fw-bold"
          onClick={() => navigate(-1)}
        >
          <span style={{ display: "inline-flex", alignItems: "center" }}>
            <ArrowBackIosIcon />
          </span>{" "}
          Back
        </h5>
      </div>
      <Box className="form_wrapper">
        <form onSubmit={formik.handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Box className="prfl_img">
                <img
                  src={
                    profileImg || ProfilePic   
                  }
                  alt="User Image"
                />
                <label htmlFor="icon-button-file">
                  <TextField
                    inputProps={{
                      accept: "image/jpeg, image/jpg, image/png",
                    }}
                    id="icon-button-file"
                    type="file"
                    sx={{ display: "none" }}
                    onChange={(val) => imageHandler(val)}
                  />
                  <EditIcon />
                </label>
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box className="inpt_bx">
                <Typography variant="h6">First Name</Typography>
                <TextField
                  fullWidth
                  name="fname"
                  placeholder="Name"
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                  value={formik.values.fname}
                  error={Boolean(formik.touched.fname && formik.errors.fname)}
                  helperText={formik.touched.fname && formik.errors.fname}
                />
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box className="inpt_bx">
                <Typography variant="h6">Last Name</Typography>
                <TextField
                  fullWidth
                  name="lname"
                  placeholder="Last Name"
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                  value={formik.values.lname}
                  error={Boolean(formik.touched.lname && formik.errors.lname)}
                  helperText={formik.touched.lname && formik.errors.lname}
                />
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box className="inpt_bx">
                <Typography variant="h6">Username</Typography>
                <TextField
                  fullWidth
                  name="userName"
                  placeholder="Username"
                  disabled
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                  value={formik.values.userName}
                  error={Boolean(
                    formik.touched.userName && formik.errors.userName
                  )}
                  helperText={formik.touched.userName && formik.errors.userName}
                />
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box className="inpt_bx">
                <Typography variant="h6">Email</Typography>
                <TextField
                  fullWidth
                  name="email"
                  placeholder="Email"
                  disabled
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.email}
                  error={Boolean(formik.touched.email && formik.errors.email)}
                  helperText={formik.touched.email && formik.errors.email}
                />
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box className="inpt_bx">
                <Typography variant="h6">Date Of Birth</Typography>
                <TextField
                  fullWidth
                  name="email"
                  placeholder="Email"
                  disabled
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.dob}
                  error={Boolean(formik.touched.dob && formik.errors.dob)}
                  helperText={formik.touched.dob && formik.errors.dob}
                />
                 {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                     <DatePicker
                        label="Controlled picker"
                        value={value}
                        onChange={(newValue) => setValue(newValue)}
                      />
                  </LocalizationProvider> */}
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box className="inpt_bx">
                <Typography variant="h6">Phone Number</Typography>
                <TextField
                  fullWidth
                  name="phone"
                  type="number"
                  maxLength={12}
                  placeholder="Phone number"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.phone}
                  error={Boolean(formik.touched.phone && formik.errors.phone)}
                  helperText={formik.touched.phone && formik.errors.phone}
                />
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box className="inpt_bx">
                <Typography variant="h6">Address</Typography>
                <TextField
                  fullWidth
                  name="address"
                  placeholder="Address"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.address}
                  error={Boolean(
                    formik.touched.address && formik.errors.address
                  )}
                  helperText={formik.touched.address && formik.errors.address}
                />
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box className="inpt_bx">
                <Typography variant="h6">City</Typography>
                <TextField
                  fullWidth
                  name="country"
                  placeholder="Country"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.city}
                  error={Boolean(
                    formik.touched.city && formik.errors.city
                  )}
                  helperText={formik.touched.city && formik.errors.city}
                />
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box className="inpt_bx">
                <Typography variant="h6">Postcode</Typography>
                <TextField
                  name="totalGroup"
                  fullWidth
                  placeholder="0"
                  disabled
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.postcode}
                  error={Boolean(
                    formik.touched.postcode && formik.errors.postcode
                  )}
                  helperText={
                    formik.touched.postcode && formik.errors.postcode
                  }
                />
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box className="inpt_bx">
                <Typography variant="h6">Country</Typography>
                <TextField
                  fullWidth
                  name="country"
                  placeholder="Country"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.country}
                  error={Boolean(
                    formik.touched.country && formik.errors.country
                  )}
                  helperText={formik.touched.country && formik.errors.country}
                />
              </Box>
            </Grid>
           
            <Grid item xs={6}>
              <Box className="inpt_bx">
                <Typography variant="h6">Total Group Created</Typography>
                <TextField
                  name="totalGroup"
                  fullWidth
                  placeholder="0"
                  disabled
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.totalGroup}
                  error={Boolean(
                    formik.touched.totalGroup && formik.errors.totalGroup
                  )}
                  helperText={
                    formik.touched.totalGroup && formik.errors.totalGroup
                  }
                />
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box className="inpt_bx">
                <Typography variant="h6">Total Groups Participated</Typography>
                <TextField
                  fullWidth
                  name="totalParticipant"
                  placeholder="0"
                  disabled
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.totalParticipant}
                  error={Boolean(
                    formik.touched.totalParticipant &&
                      formik.errors.totalParticipant
                  )}
                  helperText={
                    formik.touched.totalParticipant &&
                    formik.errors.totalParticipant
                  }
                />
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box className="inpt_bx">
                <Typography variant="h6">Member Type</Typography>
                <TextField
                  fullWidth
                  placeholder="Paid/ Unpaid"
                  name="memberType"
                  disabled
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.memberType}
                  error={Boolean(
                    formik.touched.memberType && formik.errors.memberType
                  )}
                  helperText={
                    formik.touched.memberType && formik.errors.memberType
                  }
                />
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box className="inpt_bx">
                <Typography variant="h6">Membership Purchased Date</Typography>
                <TextField
                  fullWidth
                  placeholder=""
                  disabled
                  name="membership"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.membership || 'Not Purchased Yet'}
                  error={Boolean(formik.touched.membership && formik.errors.membership)}
                  helperText={formik.touched.membership && formik.errors.membership}
                />
              </Box>
            </Grid>
            <Grid item xs={6}>
                <Box className="inpt_bx">
                  <Typography variant="h6">
                    Role
                  </Typography>
                  <div
                    className="tab_btns"
                  >
                    <div
                      className={
                      userRole === USER_ROLES.ADMIN ?  "tab_btn active" : 'tab_btn'
                      }
                      onClick={() => setUserRole(USER_ROLES.ADMIN)}
                    >
                      {USER_ROLES.ADMIN.toUpperCase()}
                    </div>
                    <div
                      className={
                      userRole === USER_ROLES.USER ?  "tab_btn active" : 'tab_btn'
                      }
                      onClick={() => setUserRole(USER_ROLES.USER)}
                    >
                     {USER_ROLES.USER.toUpperCase()}
                    </div>
                    <div
                      className={
                      userRole === USER_ROLES.TEST ?  "tab_btn active" : 'tab_btn'
                      }
                      onClick={() => setUserRole(USER_ROLES.TEST)}
                    >
                     {USER_ROLES.TEST.toUpperCase()}
                    </div>
                  </div>
                </Box>
              </Grid>
          </Grid>
          <Box sx={{ my: 3 }}>
            <Button type="submit" className="btn btn-design">
              Save
            </Button>
          </Box>
        </form>
      </Box>
    </Box>
  );
};
export default UserEdit;
